import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Styles from './ValidateButton.styles';

const ButtonWrapper = styled.div`${Styles.buttonWrapper}`; // prettier-ignore
const ButtonContainer = styled.div`${Styles.buttonContainer}`; // prettier-ignore
const StyledSpinner = styled.div`${Styles.styledSpinner}`; // prettier-ignore
const Icon = styled.img`${Styles.icon}`;

/**
 * ValidateButton component
 * @param {func} props.action - button action
 * @param {string} props.className - modifier class
 * @param {string} props.message - button message
 * @param {string} props.status - component status
 * @returns {JSX}
 */
const ValidateButton = ({
  action, className, message, disabled, image, isLoading, backgroundColor, textColor,
  marginTop, width
}) => {
  const backgroundColorButton = backgroundColor || '#FF3094';
  const Spinner = ({ color = 'white', size = 18 }) => (
    <StyledSpinner role="img" aria-label="Loading" color={color} size={size}>
      <div />
      <div />
      <div />
      <div />
    </StyledSpinner>
  );

  const Info = () => { return (<>  {image ? <Icon src={image} width="20px" /> : ''} {message} </>); };

  return (
    <ButtonContainer style={{ marginTop }} className={className} onClick={!disabled ? action : undefined} disabled={disabled}>
      <ButtonWrapper textColor={textColor} width={width} style={disabled || isLoading ? { opacity: '0.7', backgroundColor: backgroundColorButton } : { backgroundColor: backgroundColorButton }}>
        {isLoading ? <Spinner /> : <Info />}
      </ButtonWrapper>
    </ButtonContainer>
  );
};

ValidateButton.propTypes = {
  action: PropTypes.func,
  className: PropTypes.string,
  message: PropTypes.string,
  status: PropTypes.oneOf(['disabled', 'valid', 'error', 'normal'])
};

export default ValidateButton;
